export const config = {
   backendUrl: process.env.REACT_APP_BACKEND_URL || '',
   termsVersion: process.env.REACT_APP_TERMS_VER || '',
   termsUrl: process.env.REACT_APP_TERMS_URL || '',
};
